import _isFunction from "lodash/isFunction";
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, FranchiseeFunds } from 'components';
import { smallRedText } from 'styles';
import { balanceSummary, balanceField, balanceLabel, balanceAmount } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FranchiseeFundsTab = function FranchiseeFundsTab(_ref) {
  var _fundsBalance$deposit, _fundsBalance$withdra, _fundsBalance$balance;

  var id = _ref.id,
      fundsBalance = _ref.fundsBalance,
      depositBalance = _ref.depositBalance,
      onAddSubtract = _ref.onAddSubtract;

  var handleAddSubtract = function handleAddSubtract() {
    return _isFunction(onAddSubtract) && onAddSubtract();
  };

  return ___EmotionJSX(React.Fragment, null, fundsBalance && ___EmotionJSX(Paper, {
    noPadding: true,
    margin: "0 0 1.5em 0"
  }, ___EmotionJSX("div", {
    css: balanceSummary
  }, ___EmotionJSX("div", {
    css: balanceField
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u041E\u0431\u0449\u043E \u0434\u0430\u0434\u0435\u043D\u0438"), ___EmotionJSX("span", {
    css: balanceAmount
  }, (_fundsBalance$deposit = fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.deposits) !== null && _fundsBalance$deposit !== void 0 ? _fundsBalance$deposit : 0, " ", fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.currency)), ___EmotionJSX("div", {
    css: balanceField
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u041E\u0431\u0449\u043E \u0432\u044A\u0440\u043D\u0430\u0442\u0438"), ___EmotionJSX("span", {
    css: balanceAmount
  }, (_fundsBalance$withdra = fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.withdraws) !== null && _fundsBalance$withdra !== void 0 ? _fundsBalance$withdra : 0, " ", fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.currency)), ___EmotionJSX("div", {
    css: balanceField
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u0411\u0430\u043B\u0430\u043D\u0441"), ___EmotionJSX("span", {
    css: balanceAmount
  }, (_fundsBalance$balance = fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.balance) !== null && _fundsBalance$balance !== void 0 ? _fundsBalance$balance : 0, " ", fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.currency))), (depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.balance) !== (fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.balance) && ___EmotionJSX("div", {
    style: {
      padding: '0 1.6em 1em'
    }
  }, ___EmotionJSX("small", {
    css: smallRedText
  }, "\u041C\u043E\u043B\u044F, \u043E\u0431\u044A\u0440\u043D\u0435\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435 \u043D\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438!"))), ___EmotionJSX(Row, {
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    margin: "0 0 2em 0"
  }, ___EmotionJSX(FranchiseeFunds, {
    id: id,
    onAddSubtract: handleAddSubtract
  })))));
};

FranchiseeFundsTab.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fundsBalance: PropTypes.object,
  depositBalance: PropTypes.object,
  onAddSubtract: PropTypes.func
};
export default FranchiseeFundsTab;